import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/filter-fields.action';

export interface FilterFieldsState {
  fields: { [key: string]: { id: number; name: string }[] };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: FilterFieldsState = {
  fields: {},
  loaded: false,
  loading: false,
};

export const filterFieldsReducer = createReducer(
  initialState,

  on(pageActions.LoadFilterFields, (state: FilterFieldsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadFilterFieldsSuccess, (state: FilterFieldsState, { fields }) => {
    return {
      ...state,
      fields,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadFilterFieldsFail, (state: FilterFieldsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getFilterFields = (state: FilterFieldsState) => state.fields;
export const getFilterFieldsLoading = (state: FilterFieldsState) => state.loading;
export const getFilterFieldsLoaded = (state: FilterFieldsState) => state.loaded;
export const getFilterFieldsError = (state: FilterFieldsState) => state.error;
